module.exports = __webpack_public_path__ + "static/media/button-menu-open.08a63355.svg";